import React, { Component, Fragment } from 'react';
import { Dropdown, IDropdownOption, TextField, Toggle} from "office-ui-fabric-react";
import {License, LICENSE_DROPDOWN_OPTIONS, ONBOARD_STATUS_DROPDOWN_OPTIONS, OnboardStatus} from "../models/School";

export interface SchoolFilter
{
    filterString: string;
    showDisabled: boolean;
    showExpired: boolean;
    showOnlyThirdPartySds: boolean;
    licenses: License[];
    onboardStatuses: OnboardStatus[];
}

interface SchoolFilterControlsProps {
    filter: SchoolFilter;
    filterChanged: (editedFilter: SchoolFilter) => void;
    onEnterPressed?: () => void;
}

interface SchoolFilterControlsState {
}

export const handleDropdownMultiSelect = (optionFromEvent: IDropdownOption | undefined, getSelectedKeysFromState: () => any[], updateState: (updatedKeys: any[]) => void) => {

    if(!optionFromEvent) {
        return
    }

    let newSelectedKeys = [...getSelectedKeysFromState()];

    if (optionFromEvent.selected) {
        newSelectedKeys.push(optionFromEvent.key);
    }

    else {
        const currIndex = newSelectedKeys.indexOf(optionFromEvent.key);
        if (currIndex > -1) {
            newSelectedKeys.splice(currIndex, 1);
        }
    }

    updateState(newSelectedKeys);
};

export default class SchoolFilterControls extends Component<SchoolFilterControlsProps ,SchoolFilterControlsState> {
    static displayName = SchoolFilterControls.name;
    
    constructor(props: SchoolFilterControlsProps) {
        super(props);

        this.state = {
            editedFilter: Object.assign({},props.filter),
        }
    }
    
    async componentDidUpdate(prevProps: Readonly<SchoolFilterControlsProps>, prevState: SchoolFilterControlsState): Promise<void> {
        
        if(this.props.filter !== prevProps.filter)
        {
            this.setState({
                editedFilter: Object.assign({},this.props.filter)
            });
        }
    }
    
    private updateFilter(patch: Partial<SchoolFilter>)
    {
        const newFilter = Object.assign({}, this.props.filter, patch);
        this.props.filterChanged(newFilter);
    }
    
    render () {

        return(
            <Fragment>
                <div className="filter-controls p-top-1rem">
                    <div className="filter-controls__row">
                        <TextField className="filter-controls__input" autoFocus label="School Name/Code, Tenant Name/Id, License Ref" placeholder="Filter"
                                   onKeyUp={(keyEvent) => {
                                       if(keyEvent.key === "Enter" && this.props.onEnterPressed)
                                       {
                                           this.props.onEnterPressed();
                                       }
                                   }}
                                   onChange={(event,newValue) => {
                                        this.updateFilter({
                                            filterString: newValue?.toLowerCase()
                                        });
                                    }
                        }/>

                        <Dropdown
                            multiSelect={true}
                            className="filter-controls__input"
                            label="License"
                            selectedKeys={this.props.filter.licenses}
                            onChange={(e,option)=> {
                                handleDropdownMultiSelect(option,() => this.props.filter.licenses,(updatedLicenseFilter) => {
                                    this.updateFilter({licenses: updatedLicenseFilter});
                                });
                            }}
                            options={LICENSE_DROPDOWN_OPTIONS}
                            styles={{ dropdown: { width: 300 } }}
                            placeholder={"All Licenses"}
                        />

                        <Dropdown
                            multiSelect={true}
                            className="filter-controls__input"
                            label="Onboard status"
                            selectedKeys={this.props.filter.onboardStatuses}
                            onChange={(e,option)=> {
                                handleDropdownMultiSelect(option,() => this.props.filter.onboardStatuses,(updatedOnboardStatusFilter) => {
                                    this.updateFilter({onboardStatuses: updatedOnboardStatusFilter});
                                });
                            }}
                            options={ONBOARD_STATUS_DROPDOWN_OPTIONS}
                            styles={{ dropdown: { width: 300 } }}
                            placeholder={"All Onboard Statuses"}
                        />

                        <Toggle
                            className={"p-left-1rem p-top-2rem"}
                            inlineLabel={true}
                            checked={this.props.filter.showDisabled}
                            onChange={(event, newValue) => {
                                this.updateFilter({
                                    showDisabled: newValue!
                                });
                            }}
                            role="switch"
                            label={"Show disabled"}
                        />

                        <Toggle
                            className={"p-left-1rem p-top-2rem"}
                            inlineLabel={true}
                            checked={this.props.filter.showExpired}
                            onChange={(event, newValue) => {
                                this.updateFilter({
                                    showExpired: newValue!
                                });
                            }}
                            role="switch"
                            label={"Show expired"}
                        />

                        <Toggle
                            className={"p-left-1rem p-top-2rem"}
                            inlineLabel={true}
                            checked={this.props.filter.showOnlyThirdPartySds}
                            onChange={(event, newValue) => {
                                this.updateFilter({
                                    showOnlyThirdPartySds: newValue!
                                });
                            }}
                            role="switch"
                            label={"Show only third party SDS"}
                        />

                    </div>
                </div>
                
            </Fragment>
        );
    }
}